import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActivitySpinnerComponent} from '../../../../../shared/components/activity-spinner/activity-spinner.component';
import {NgClass} from '@angular/common';
import {VehicleBrand} from '../../../../../domain/core/vehicle-brand.model';

@Component({
  selector: 'app-wizard-mail-summary',
  imports: [
    ActivitySpinnerComponent,
    NgClass
  ],
  standalone: true,
  templateUrl: './wizard-mail-summary.component.html'
})
export class WizardMailSummaryComponent {
  @Input() brand: VehicleBrand;
  @Input() confirmWithMailInProgress = false;
  @Input() confirmWithoutMailInProgress = false;

  @Output() sendMailSummary = new EventEmitter<string>();
  @Output() withoutMailSummary = new EventEmitter<void>();
}
